import { render, staticRenderFns } from "./wechatVideoInfoDetails.vue?vue&type=template&id=31aef971"
import script from "./wechatVideoInfoDetails.vue?vue&type=script&lang=js"
export * from "./wechatVideoInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./wechatVideoInfoDetails.vue?vue&type=style&index=0&id=31aef971&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports